import axios, { AxiosInstance } from "axios";

let baseURL: string | undefined;

switch (process.env.NODE_ENV) {
  case "development":
    baseURL = process.env.REACT_APP_API_URL_DEV;
    break;
  case "production":
    baseURL = process.env.REACT_APP_API_URL_PROD;
    break;
  case "test":
    baseURL = process.env.REACT_APP_API_URL_TEST;
    break;
  default:
    throw new Error(`Unknown NODE_ENV: ${process.env.NODE_ENV}`);
}

/**
 * Public API client — no Authorization header.
 * Use for unauthenticated endpoints (invite validation, accept, etc.)
 */
export const publicClient: AxiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Handle FormData content-type automatically
publicClient.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});
